var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "basic-table" },
    [
      _vm.type === "manage"
        ? _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: { data: _vm.TableData, border: "" },
              on: { "selection-change": _vm.selectGoods }
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55", fixed: "left" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "序号", width: "60", type: "index" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "ruigu_code",
                  label: "锐锢商城编码",
                  width: "110"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "self_code", label: "商品编码", width: "60" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "name", label: "商品名称", width: "330" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "spec", label: "规格型号", width: "210" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "c_name", label: "分类", width: "100" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "b_name", label: "品牌" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "is_enable", label: "状态" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "is_sale", label: "是否在售" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { fixed: "right", label: "操作", width: "80" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(
                            "el-button",
                            {
                              staticStyle: { color: "#236bdc" },
                              attrs: { type: "text" },
                              on: {
                                click: function($event) {
                                  return _vm.editGoods(scope.row.id)
                                }
                              }
                            },
                            [_vm._v("编辑")]
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  1654637456
                )
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.type === "classify"
        ? _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.TableData,
                border: "",
                "row-class-name": _vm.tableRowClassName
              },
              on: { "selection-change": _vm.handleSelectionChange }
            },
            [
              _c("el-table-column", {
                attrs: {
                  type: "selection",
                  selectable: _vm.checkboxInit,
                  width: "55"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "序号", width: "60", type: "index" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "bianma", label: "已选品", width: "60" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c("i", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: scope.row.is_select === 1,
                                expression: "scope.row.is_select===1"
                              }
                            ],
                            staticClass: "el-icon-success"
                          })
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  1226802226
                )
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "bianma", label: "锐锢商城编码", width: "180" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "product_name", label: "商品名称", width: "360" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "model", label: "规格型号", width: "200" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "c_name", label: "分类" }
              }),
              _vm._v(" "),
              _c("el-table-column", { attrs: { prop: "name", label: "品牌" } }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "is_sale", label: "是否在售" }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d542a3a4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d542a3a4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/basic/basic-table.vue
// module id = null
// module chunks = 